import { Link } from "@amzn/awsui-components-react";
import {
    getApprovalDeadlineConfig,
    getReviewDeadlineConfig,
    getFilingDeadlineConfig,
    handleObligationClick
} from "../../Constants/Constants";
import { formatStatus, statusColorCodes } from "../../../../common/utils/commonUtils";
import { formatDate } from "../../../../common/utils/apiUtils";

export const getColumnDefinitions = (navigate) => {
    return [
      {
        id: 'obligation',
        header: 'Obligation',
        cell: item => {
          return (
              <Link onFollow={() => handleObligationClick(item, navigate)}>{item.obligationName}</Link>
          )
        },
        minWidth: '160px'
      },
      {
        id: 'country',
        header: 'Country',
        cell: item => item.country,
        minWidth: '30px'
      },
      {
        id: 'entity',
        cell: item => item.entity,
        header: 'Entity',
        sortingField: "entity",
        minWidth: '80px'
      },
      {
        id: 'period',
        cell: item => item.reportingPeriod,
        header: 'Period',
        sortingField: "reportingPeriod",
        minWidth: '40px'
      },
      {
        id: 'status',
        header: 'Status',
        cell: item => {
          const statusValue = formatStatus(item.status)
          return (<div style={statusColorCodes(statusValue)}>{statusValue}</div>)
        },
        sortingField: "status",
        minWidth: '60px'
      },
      {
        id: 'reviewDeadline',
        header: 'Review Deadline',
        cell: item => {
          const config = getReviewDeadlineConfig(item);
          return (<div style={{color: config.color}}>{config.icon} {formatDate(item.reviewDeadline)}</div>)
        },
        sortingField: "filingDeadline",
        minWidth: '80px'
      },
      {
        id: 'approvalDeadline',
        header: 'Approval Deadline',
        cell: item => {
          const config = getApprovalDeadlineConfig(item);
          return (<div style={{color: config.color}}>{config.icon} {formatDate(item.approvalDeadline)}</div>)
        },
        sortingField: "filingDeadline",
        minWidth: '80px'
      },
      {
        id: 'filingDeadline',
        header: 'Filing Deadline',
        cell: item => {
          const config = getFilingDeadlineConfig(item);
          return (<div style={{color: config.color}}>{config.icon} {formatDate(item.filingDeadline)}</div>)
        },
        sortingField: "filingDeadline",
        minWidth: '100px'
      }
    ];
  };